import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';

export const useStyles = makeStyles(({ fontWeights, palette }: Theme) => ({
  wrapper: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    gap: '0.5rem',
    minHeight: '3.75rem',
    paddingBottom: '0.5rem',
    borderBottom: `2px solid ${palette.grey[400]}`,
  },
  medium: {
    margin: '2rem 0',
  },
  title: {
    paddingRight: '2rem',
    margin: 0,
    fontWeight: fontWeights.medium,
    fontSize: '1rem',
    lineHeight: 1.2,
  },
  text: {
    paddingRight: '2rem',
  },
  button: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    padding: 0,
    border: 'none',
    borderRadius: 0,
    background: 'transparent',
  },
  icon: {
    position: 'absolute',
    right: 0,
    bottom: '0.5rem',
  },
  iconSmall: {
    position: 'absolute',
    right: '0.25rem',
    bottom: '0.75rem',
  },
  asterisk: {
    position: 'relative',
    top: 2,
    right: 0,
    color: palette.error.main,
    fontSize: '1.5rem',
  },
  disclaimer: {
    margin: '0.5rem 0 0',
    color: palette.error.dark,
  },
}));
